import metrics from 'maps/metrics';

import formatDate from 'helpers/formatDate';

import { ITableHeader } from 'components/data-containers/PlaylistTable/util/getMenuItems';

type TProps = {
  isTopList: boolean;
  headers: any[];
  dateAdded: any;
  lastPeakDate: any;
  peak: any;
  totalDays: any;
  customerName: string;
  playlist: any;
};

const getPlaylistKeyValueGroupItems = ({
  isTopList,
  headers,
  dateAdded,
  lastPeakDate,
  peak,
  totalDays,
  customerName,
  playlist,
}: TProps): any[] => {
  const playlistKeyValueGroupItems: any[] = isTopList
    ? [
        {
          label: 'DSP',
          metric: customerName,
          type: 'raw',
        },
        {
          label: 'New Track count',
          metric: playlist.newTrackCount?.toString() || '',
          type: 'raw',
        },
        {
          label: 'Track count',
          metric: playlist.totalTrackCount?.toString() || '',
          type: 'raw',
        },
      ]
    : [
        {
          label: 'Playlist Territory',
          metric: metrics['playlistTerritories'],
          headerValue: 'countryId',
        },
        {
          label: 'DSP',
          metric: customerName,
          type: 'raw',
          headerValue: 'customerId',
        },
        {
          label: 'Skiprate',
          metric: metrics['skiprate_this_week_to_date'],
          type: 'percentage',
          headerValue: 'skiprate_this_week_to_date',
        },
        {
          label: 'Track Count',
          metric: metrics['track_count'],
          headerValue: 'track_count',
        },
        {
          label: 'Followers',
          metric: metrics['followers'],
          headerValue: 'followers',
        },
        {
          label: 'Date added',
          metric: formatDate(dateAdded, 'day-short'),
          type: 'raw',
          headerValue: 'dateAdded',
        },
        {
          label: 'Total days',
          metric: totalDays,
          type: 'raw',
          headerValue: 'totalDays',
        },
        {
          label: 'Position',
          metric: metrics['position'],
          headerValue: 'position',
        },
        {
          label: 'Streams',
          metric: metrics['stream_count_this_week_to_date'],
          headerValue: 'stream_count_this_week_to_date',
        },
        {
          label: 'Peak',
          metric: peak,
          type: 'raw',
          headerValue: 'peak',
        },
        {
          label: 'Last peak date',
          metric: formatDate(lastPeakDate, 'day-short'),
          type: 'raw',
          headerValue: 'lastPeakDate',
        },
      ];

  const sortedHeaders = isTopList
    ? playlistKeyValueGroupItems
    : playlistKeyValueGroupItems.filter((item: any) => {
        const uniqueHeaders = [
          'dateAdded',
          'totalDays',
          'peak',
          'lastPeakDate',
        ];
        return uniqueHeaders.indexOf(item.headerValue) > -1
          ? item
          : headers.find(
              (header: ITableHeader) => header.value === item.headerValue
            );
      });

  return sortedHeaders;
};

export default getPlaylistKeyValueGroupItems;
